export default "__VITE_ASSET__B27YAeR5__"